module.exports = __webpack_public_path__ + "img/logo-nopf.b19fbd3d.svg";